/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconPause from '@telus-uds/palette-public-mobile/build/rn/icons/Pause'
import PaletteIconPlaySolid from '@telus-uds/palette-public-mobile/build/rn/icons/PlaySolid'
import PaletteIconReplay from '@telus-uds/palette-public-mobile/build/rn/icons/Replay'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    borderColor: '#f9f2dd',
    pauseIcon: PaletteIconPause,
    playIcon: PaletteIconPlaySolid,
    replayIcon: PaletteIconReplay
  }
}
export default theme
